<div class="flex flex-col gap-4">
  <p class="text-sm font-semibold font-['Roboto_Condensed'] text-slate-600">Prepayment Requests</p>
  @if (availableTaList().length > 0) {
    <div class="flex gap-2 items-center">
      @if (selectedCount() > 0) {
        <p-button size="small" label="Process Prepayment for Selected TAs" data-testid="process-selected-tas" (onClick)="processSelectedPrepaymentsClicked.emit(selectedTaList())"></p-button>
      } @else {
        <input type="text"
               pInputText
               [(ngModel)]="searchStr"
               class="w-1/2"
               pSize="small"
               placeholder="Type to filter by TA number, destination, status or staff..."
        />
        <div class="bg-white rounded-lg">
          <p-button outlined severity="secondary"
                    size="small"
                    (onClick)="clearSearchStr()">Clear</p-button>
        </div>
      }
    </div>

    <p-table [value]="filteredTaList()"
             stripedRows
             [tableStyle]="{'min-width': '40rem'}"
             sortField="taNumber"
             [sortOrder]="-1"
             class="ta-list ta-list-dense border-[1px] border-surface-300 rounded-lg">
      <ng-template #header>
        <tr class="text-datatable-header-cell-color text-xs font-semibold font-['Roboto_Condensed']">
          <th class="rounded-tl-lg w-8">
            <p-checkbox [binary]="true" size="small"
                        [ngModel]="allFilteredSelected()"
                        (onChange)="setAllFilteredSelected($event.checked)"
                        [attr.data-testid]="'select-all-tas'" />
          </th>
          <th class="ta-col-prepaid"></th>
          <th class="ta-col-attachment"></th>
          <th>TA Number</th>
          <th pSortableColumn="startDate" style="align-items: center">
            <div class="flex items-center gap-2">
              Travel Date
              <p-sortIcon field="startDate" />
            </div>
          </th>
          <th>Status</th>
          <th>Primary Traveller</th>
          <th>No. of Travellers</th>
          <th>Project Code</th>
          <th style="padding-left: 4px; padding-right: 4px; text-align: center;">Total TA Value</th>
          <th style="padding-left: 4px; padding-right: 4px; text-align: center;">Prepayment Component</th>
          <th class="ta-col-actions">Actions</th>
          <th class="rounded-tr-lg ta-col-comments"></th>
        </tr>
      </ng-template>
      <ng-template #body let-taSubmission let-rowIndex="rowIndex">
        <tr class="text-xs font-normal font-['Roboto_Condensed'] hover:cursor-pointer" (click)="setSelectedTa(taSubmission)" (dblclick)="viewTaSubmission(taSubmission)">
          <td [ngClass]="{'bg-primary-50': (taSubmission.id === store.taSubmission()?.id), 'rounded-bl-lg': (rowIndex === availableTaList().length - 1)}"
              (click)="$event.stopPropagation()" (dblclick)="$event.stopPropagation()">
            <p-checkbox [binary]="true" size="small"
                        [ngModel]="isSelected(taSubmission)"
                        (onChange)="setSelected(taSubmission, $event.checked)"
                        [attr.data-testid]="'select-ta-' + taSubmission.taNumber" />
          </td>
          <td class="ta-col-prepaid" [ngClass]="{'bg-primary-50': (taSubmission.id === store.taSubmission()?.id)}">
            <prepaid-indicator [taDetails]="taSubmission"></prepaid-indicator>
          </td>
          <td class="ta-col-attachment" [ngClass]="{'bg-primary-50': (taSubmission.id === store.taSubmission()?.id)}">
            <attachment-indicator [taDetails]="taSubmission"></attachment-indicator>
          </td>
          <td [ngClass]="{'bg-primary-50': (taSubmission.id === store.taSubmission()?.id)}">
            <button class="text-primary-500 hover:underline font-semibold cursor-pointer"
                    (click)="viewTaSubmission(taSubmission); $event.stopPropagation()">
              {{taSubmission.taNumber}}
            </button>
          </td>
          <td [ngClass]="{'bg-primary-50': (taSubmission.id === store.taSubmission()?.id)}">{{taSubmission.startDate | date:'dd/MM/yy'}}</td>
          <td [ngClass]="{'bg-primary-50': (taSubmission.id === store.taSubmission()?.id)}">
            <p-chip>
              <div class="whitespace-nowrap">{{toTAStatusText(taSubmission.status)}}</div>
            </p-chip>
          </td>
          <td [ngClass]="{'bg-primary-50': (taSubmission.id === store.taSubmission()?.id)}">
            <div class="flex gap-1 items-center">
              @if (taSubmission.travellerCount > 1) {
                <i class="fa-solid fa-users"></i>
              } @else {
                <i class="fa-solid fa-user"></i>
              }
              <span class="text-nowrap">{{taSubmission.primaryTraveller?.details?.name}}</span>
            </div>
          </td>
          <td [ngClass]="{'bg-primary-50': (taSubmission.id === store.taSubmission()?.id)}">{{taSubmission.travellerCount}}</td>
          <td [ngClass]="{'bg-primary-50': (taSubmission.id === store.taSubmission()?.id)}">{{taSubmission.projectCode}}</td>
          <td [ngClass]="{'bg-primary-50': (taSubmission.id === store.taSubmission()?.id)}" style="padding: 2px 4px;"><ta-cost-bubble severity="outlined" [tableVersion]="true" [value]="taSubmission.currentValue ?? taSubmission.originalValue ?? 0"></ta-cost-bubble></td>
          <td [ngClass]="{'bg-primary-50': (taSubmission.id === store.taSubmission()?.id)}" style="padding: 2px 4px;"><ta-cost-bubble severity="success" [tableVersion]="true" [value]="taPaymentComponents(taSubmission).prepayment"></ta-cost-bubble></td>
          <td class="ta-col-actions" [ngClass]="{'bg-primary-50': (taSubmission.id === store.taSubmission()?.id)}" style="padding: 2px;">
            <div class="flex flex-col justify-start">
              <p-button [text]="true" severity="primary" size="small" (onClick)="viewTaSubmission(taSubmission)"><span class="text-nowrap text-xs">Review Full TA</span></p-button>
              <p-button [text]="true" severity="primary" size="small" (onClick)="processPrepaymentTaClicked.emit(taSubmission)"><span class="text-nowrap text-xs">Process Prepayment</span></p-button>
            </div>
          </td>
          <td class="ta-col-comments" [ngClass]="{'bg-primary-50': (taSubmission.id === store.taSubmission()?.id), 'rounded-br-lg': (rowIndex === availableTaList().length - 1)}">
            <ta-comment-count [count]="taSubmission.commentCount"></ta-comment-count>
          </td>
        </tr>
      </ng-template>
      <ng-template #footer>
        @if (filteredTaList().length === 0) {
          <tr class="text-xs font-normal font-['Roboto_Condensed']">
            <td class="rounded-bl-lg rounded-br-lg" colspan="13"><i>Your search returned no results.</i></td>
          </tr>
        }
      </ng-template>
    </p-table>
  } @else {
    <div class="self-stretch justify-start text-slate-500 text-sm font-normal font-['Inter'] leading-6">There are no unprocessed prepayments</div>
  }
</div>
